<template>
  <header>
    <StatusBar/>
    <TopNav/>
  </header>
</template>
<script>
import StatusBar from "./header/StatusBar.vue";
import TopNav from "./header/TopNav.vue";
export default {
  components: {
    StatusBar,
    TopNav
  }
}
</script>